import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { breakpoints, mobileCSS } from '@measures/responsive'

const StyledContainer = styled.div<{ hideInDesktop?: boolean }>`
  ${({ hideInDesktop }) => {
    return hideInDesktop
      ? css`
          @media ${breakpoints.desktop} {
            display: none;
          }
        `
      : css`
          @media ${breakpoints.tablet} {
            display: none;
          }

          @media ${breakpoints.mobile} {
            display: none;
          }
        `
  }}

  ${({
    theme: {
      colors: {
        grey: { grey_20 },
      },
      measures: {
        stretch,
        playlist: { height: playlistHeight, width: playlistWidth },
      },
    },
  }) => {
    return css`
      position: relative;
      display: flex;
      flex-direction: column;
      background-color: ${grey_20};
      padding-bottom: 18px;

      @media ${breakpoints.desktop} {
        /* width: ${playlistWidth}; */
        height: ${playlistHeight};

        padding-bottom: 0;
      }

      ${mobileCSS(css`
        ${stretch('left')}
        ${stretch('right')}
      `)}
    `
  }}
`

type ContainerProps = {
  hideInDesktop?: boolean
  children?: React.ReactNode
}

const Container: FunctionComponent<ContainerProps> = ({
  children,
  hideInDesktop = false,
}) => {
  return (
    <StyledContainer hideInDesktop={hideInDesktop}>{children}</StyledContainer>
  )
}

export default Container
